import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';

import { WebSearchService } from './web-search.service';
import { Plan, AppContext, SeoService } from './../shared';

@Component({
  selector: 'web-search',
  template: require('./web-search.component.html'),
  styles: [require('./web-search.component.scss')],
  providers: [WebSearchService],
})
export class WebSearchComponent implements OnInit {
  plans: Observable<Plan[]>;

  sub: any;
   
  title = 'Ocean Container Shipping Schedule Plans - Linescape';
  description = 'Linescape offers various subscription plans to access liner shipping schedules, routes, ports, vessels or carrier data.';

  enterprisePlanLevel: string = '6';

  constructor(private service: WebSearchService, private route: ActivatedRoute, private router: Router, public app: AppContext, private seo: SeoService) {
  }

  ngOnInit() {
    this.seo.set(this.title, this.description);
    window.scrollTo(0, 0);
    this.getPlans();
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  getPlans() {
    this.plans = this.service.getPlans();
  }

  monthly() {
    this.service.yearlyBilling = false;
  }

  yearly() {
    this.service.yearlyBilling = true;
  }

  openRegister(planType) {
    if (!this.service.app.isLoggedIn) {
      if (planType === 'Premium') {
        this.app.signUpPlan = 'Premium';
      } else if (planType === 'Professional') {
        this.app.signUpPlan = 'Professional';
      } else if (planType === 'Enterprise') {
        if (this.enterprisePlanLevel == '6') {
          this.app.signUpPlan = 'Enterprise6';
        } else if (this.enterprisePlanLevel == '12') {
          this.app.signUpPlan = 'Enterprise12';
        } else if (this.enterprisePlanLevel == '18') {
          this.app.signUpPlan = 'Enterprise18';
        } else {
          this.app.signUpPlan = 'Enterprise6';
        }
      } else {
        this.app.signUpPlan = 'Basic';
      }

      if (this.service.yearlyBilling) {
        this.app.signUpPlanBilling = 'yearly';
      } else {
        this.app.signUpPlanBilling = 'monthly';
      }

      this.router.navigate(['/register']);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/web-search/web-search.component.ts